export default __webpack_public_path__ + "static/dev-big-gallery-3cbe9c47e4ff058fb8ceca363d941d5a.jpg";